module.exports = __webpack_public_path__ + "static/media/Liri.463b069a.png";